import React from 'react';

const BriefcaseBusinessIcon = ({ stroke = '#616893' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 10H10.0083"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3346 5.0013V3.33464C13.3346 2.89261 13.159 2.46868 12.8465 2.15612C12.5339 1.84356 12.11 1.66797 11.668 1.66797H8.33464C7.89261 1.66797 7.46869 1.84356 7.15612 2.15612C6.84356 2.46868 6.66797 2.89261 6.66797 3.33464V5.0013"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3346 10.832C15.862 12.4645 12.9643 13.3348 10.0013 13.3348C7.03834 13.3348 4.14064 12.4645 1.66797 10.832"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.668 5H3.33464C2.41416 5 1.66797 5.74619 1.66797 6.66667V15C1.66797 15.9205 2.41416 16.6667 3.33464 16.6667H16.668C17.5884 16.6667 18.3346 15.9205 18.3346 15V6.66667C18.3346 5.74619 17.5884 5 16.668 5Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BriefcaseBusinessIcon;
